export * from './master-data-view/master-data-view.component';
